<template>
  <modal
    name="placeorderdetail"
    :minHeight="200"
    :minWidth="200"
    :maxWidth="1300"
    :scrollable="true"
    :adaptive="true"
    :reset="true"
    height="auto"
    @before-open="beforeOpen"
  >
    <div class="modal--container">
      <div class="d-flex justify-content-between pt-3">
        <h4>Place Order</h4>
        <button type="button" @click="closeModal" class="close">
          <span aria-hidden="true"
            ><font-awesome-icon icon="times" size="1x"
          /></span>
        </button>
      </div>

      <div class="d-flex flex-column">
        <div class="d-flex mt-4">
          <div class="d-flex flex-column col-6">
            <table class="table mt-3 table-bordered table-striped">
              <tbody>
                <tr>
                  <td width="50%">Order Total</td>
                  <td>${{ orderTotal }}</td>
                </tr>
                <tr>
                  <td>Subsidized Total</td>
                  <td>${{ subsidizedSubtotal }}</td>
                </tr>
                <tr>
                  <td>Need to Pay</td>
                  <td>${{ needToPay }}</td>
                </tr>
              </tbody>
            </table>

            <span
              class="total-increased mt-1"
              v-if="needToPay > subsidizedSubtotal"
              >*Food total exceeds remaining user subsidy.</span
            >
          </div>
        </div>

        <div class="d-flex flex-column mt-5">
          <span class="caption mb-2">Choose Payment Method</span>
          <tr>
            <td class="py-1">
              <div class="mb-2 d-flex align-items-center">
                <input
                  class="mr-2"
                  type="radio"
                  id="personal"
                  value="credit_card"
                  v-model="picked"
                />
                <label for="personal">Pay with credit card</label>
              </div>

              <div class="mt-2 d-flex align-items-center">
                <input
                  class="mr-2"
                  type="radio"
                  id="office"
                  value="paid_by_invoice"
                  v-model="picked"
                />
                <label for="office"
                  >Override subsidy and bill to account invoice</label
                >
              </div>
            </td>
          </tr>
        </div>

        <div class="d-flex flex-column mt-4" v-if="picked == 'credit_card'">
          <span class="caption">Choose card to complete Payment</span>
          <span class="mx-5 note mb-4">
            Please note that choosing a card saved on a user’s profile means
            they will be charged on any saved credit cards, including personal
            cards
          </span>

          <div
            v-for="card in employeeCards"
            class="credit-card"
            :key="card.card_id"
          >
            <div class="d-flex align-items-center">
              <input
                type="radio"
                :id="card.card_id"
                :value="card.card_id"
                v-model="card_id"
                class="mr-3"
              />
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/img/visa-card.png"
                    alt="visa card"
                    data-retina="true"
                    class="card-icon"
                    v-if="card.card_type == 'VI'"
                  />
                  <img
                    src="@/assets/img/card-icon.png"
                    alt="card"
                    data-retina="true"
                    class="card-icon"
                    v-else
                  />

                  <div class="d-flex flex-column ml-2">
                    <span class="card-type">{{ card.card_type }}</span>
                    <span class="card-no"
                      >**** **** ****
                      {{ card.number.substring(card.number.length - 4) }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-end mt-3">
          <div class="my-1 mr-3 my-md-0">
            <button class="other_btn gray-hover" @click.prevent="closeModal">
              Close
            </button>
          </div>

          <div class="my-1 my-md-0">
            <button
              type="submit"
              class="save_btn hover-dark"
              v-on:click.stop="pay()"
            >
              Place Order
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import {
  getEmployeeCardsOfficeAdmin,
  orderCheckoutOfficeAdmin,
  getCartOfficeAdmin
} from "../../../utils/api";
import { mapState, mapGetters } from "vuex";
import { errorHandler } from "@/utils/errorHandler";
import { showStoppedErrorAlert } from "../../../utils/common";
export default {
  name: "PlaceOrderDetailModal",
  data() {
    return {
      selectedDate: null,
      needToPay: null,
      orderTotal: null,
      orderItems: [],
      subsidizedSubtotal: null,
      employeeCards: [],
      selectedUser: null,
      card_id: "",
      paymentParams: {},
      picked: "credit_card"
    };
  },
  computed: {
    ...mapState([
      "cartOfficeAdmin",
      "selectedUserToPlaceOrder",
      "listOfOfficeEmployeesAll",
      "paymentCartOfficeAdmin"
    ]),
    ...mapGetters([
      "getFirstEmployeeId",
      "getFirstLocation",
      "getSelectedUserPlaceOrder"
    ])
  },
  methods: {
    beforeOpen(event) {
      this.card_id = "";
      this.picked = "credit_card";
      this.selectedDate = JSON.parse(
        JSON.stringify(event?.params?.selectedDate)
      );
      this.needToPay = JSON.parse(JSON.stringify(event?.params?.needToPay));
      this.orderTotal = JSON.parse(JSON.stringify(event?.params?.orderTotal));
      this.orderItems = JSON.parse(JSON.stringify(event?.params?.orderItems));
      this.selectedUser = this.listOfOfficeEmployeesAll
        .filter(emp => emp.id == this.selectedUserToPlaceOrder)
        .shift();

      this.subsidizedSubtotal = JSON.parse(
        JSON.stringify(event?.params?.subsidizedSubtotal)
      );

      this.fetchCards();
    },
    closeModal() {
      this.$modal.hide("placeorderdetail");
    },
    fetchCards() {
      let loader = this.$loading.show();
      getEmployeeCardsOfficeAdmin(
        this.getFirstEmployeeId,
        this.selectedUserToPlaceOrder
      )
        .then(response => {
          loader.hide();
          this.employeeCards = response.credit_cards;
          if (this.employeeCards.length == 1)
            this.card_id = this.employeeCards[0].card_id;
        })
        .catch(err => {
          loader.hide();
          errorHandler(err);
        });
    },
    async pay(cardType) {
      let loader = this.$loading.show();

      if (this.card_id === "" && this.picked == "credit_card") {
        loader.hide();
        this.paymentOngoing = false;
        this.$swal({
          title: "Please select a card.",
          confirmButtonText: "OK"
        });

        return;
      }

      this.paymentParams = {
        card_id: this.card_id,
        amount: this.paymentCartOfficeAdmin.payable,
        paid_by_invoice: this.picked == "paid_by_invoice",
        cutlery: this.paymentCartOfficeAdmin.checkoutParams.cutlery,
        order_billing_references_attributes: this.paymentCartOfficeAdmin
          .selectedReferences
      };

      let currentTotalItems = this.cartOfficeAdmin.items.length;

      getCartOfficeAdmin(
        this.getFirstEmployeeId,
        this.getSelectedUserPlaceOrder,
        this.$store.state.tipOfficeAdmin
      ).then(response => {
        const data = response?.data;
        this.$store.commit("SET_CART_OFFICE_ADMIN", data);

        if (currentTotalItems !== data?.all_items?.data?.length) {
          this.$swal({
            title: `${this.selectedUser.attributes.first_name} has made changes to the cart while this order was being placed, please review the updated cart before placing the order.`
          });
          loader.hide();
          return;
        } else this.cartCheckout(loader);
      });
    },
    cartCheckout(loader) {
      orderCheckoutOfficeAdmin(
        this.paymentParams,
        this.getFirstEmployeeId,
        this.getSelectedUserPlaceOrder
      )
        .then(response => {
          if (response.data && response.data.orders) {
            this.$store.dispatch("FETCH_CART_OFFICE_ADMIN");
            let message =
              "If you need any assistance, use the live-chat icon at the bottom left of the page, or email us at help@hungerhub.com.";
            this.$swal({
              title: `Order for ${this.selectedUser.attributes.first_name} ${this.selectedUser.attributes.last_name}  has been placed!`,
              text: message,
              confirmButtonText: "OK"
            });

            loader.hide();
            this.closeModal();
            this.$root.$emit("setSelectedUser", "");
          } else {
            loader.hide();

            if (
              response.data.message ==
                "There is a cart item with a stopped shipment" &&
              this.cartOfficeAdmin.items.length > 0
            ) {
              showStoppedErrorAlert(
                this,
                this.cartOfficeAdmin.items[0].attributes.restaurant_name
              );
            } else if (response?.data?.message?.includes("Unfortunately")) {
              this.closeModal();
              this.$root.$emit("setSelectedUser", "");

              if (response?.data?.message)
                this.$swal({
                  title: response?.data?.message,
                  confirmButtonText: "OK"
                });
            } else {
              if (response?.data?.message)
                this.$swal({
                  title: response.data.message,
                  confirmButtonText: "OK"
                });
            }
          }
        })
        .catch(err => {
          loader.hide();
          errorHandler(err);
          if (err?.response?.data?.message)
            this.$swal({
              title: err?.response?.data?.message,
              confirmButtonText: "OK"
            });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0px !important;
}

.note {
  font-size: 12px;
  color: #3b3b3b;
  margin-top: 4px;
}

.special-instructions {
  font-size: 12px;
  color: #545455;
}

.total-increased {
  color: #707070;
  font-size: 12;
  font-weight: normal;
}

th {
  font-weight: normal;
}

h1 {
  font-size: 24px;
  font-weight: 500;
  color: #393838;
  width: 80%;
  margin: 0;
}

h2 {
  font-size: 14px;
  font-weight: normal;
  color: #707070;
}

.caption {
  font-size: 14px;
  font-weight: normal;
  color: #393838;
}

td {
  color: #393838;
}

p {
  color: #393838;
}

.order_status {
  margin-top: 65px;
}

.modal__btn {
  border-radius: 9px;
  background-color: #6d69d3;
  color: #fff;
  font-weight: 500;
  border: none;
  padding: 8px 20px;
}

.modal--container {
  padding: 18px 30px;
  overflow-y: auto;
  max-height: 750px;
  height: 100%;
}

.close {
  color: #000000;
}

.order-status {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #373981;
}

.credit-card {
  padding: 10px 0px;
  margin-bottom: 8px;
}

.card-icon {
  width: 36px;
  height: 36px;
}

.card-type {
  color: #707070;
  font-size: 11px;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.card-no {
  color: #242a37;
  font-size: 14px;
}

@media (max-width: 767px) {
  h1 {
    font-size: 16px;
  }

  h2 {
    font-size: 12px;
  }

  span {
    font-size: 13px;
  }

  p {
    font-size: 11px;
  }

  .caption {
    font-size: 11px;
  }

  td {
    font-size: 11px;
  }

  .modal__btn {
    border-radius: 4px;
    font-weight: 500;
    border: none;
    font-size: 11px;
    padding: 4px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeAdmin/PlaceOrder/PlaceOrderDetailModal.vue